"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSLayoutFooter = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const FooterStyled = styled_components_1.default.div ``;
exports.DSLayoutFooter = react_1.default.memo(({ children }) => {
    return react_1.default.createElement(FooterStyled, { className: "bottom-nav" }, children);
});
